import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useLazyVerifyProviderQuery } from "@/redux/apis/auth/authApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { siteInfoSelector } from "@/redux/slices/config/selectors";
import { setActiveOperator } from "@/redux/slices/operator/operatorSlice";

export const DirectLogin = () => {
  const { login } = useKindeAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const siteInfo = useAppSelector(siteInfoSelector);
  const [verify] = useLazyVerifyProviderQuery();

  useEffect(() => {
    // Wait for siteInfo to be fully loaded (not empty object)
    if (!siteInfo?.key) {
      return;
    }

    // Fetch and set the domain operator as active
    verify({ providerCode: siteInfo.key, apiUrl: siteInfo.apiUrl })
      .unwrap()
      .then((res) => {
        dispatch(setActiveOperator(res));

        // Redirect to Kinde login (same as clicking Continue button)
        login({
          orgCode: res.orgCode,
        });
      })
      .catch(() => {
        // If operator not found, redirect to 404
        navigate("/404");
      });
  }, [login, verify, dispatch, navigate, siteInfo]);

  // Show loading while redirecting
  return <Loading />;
};
